import { useId, type ReactNode } from 'react';

import styles from './Field.module.css';

export interface FieldProps {
  label: ReactNode;
  hint?: ReactNode;
  layout?: 'row' | 'stacked';
  htmlFor?: string;
  className?: string;
  children: ReactNode | ((id: string) => ReactNode);
}

export function Field({
  label,
  hint,
  layout = 'row',
  htmlFor,
  className,
  children,
}: FieldProps) {
  const generatedId = useId();
  const id = htmlFor ?? generatedId;

  const cls = [styles.field, layout === 'stacked' && styles.stacked, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cls}>
      <div className={styles.label}>
        <label className={styles.labelText} htmlFor={id}>
          {label}
        </label>
        {hint && <span className={styles.hint}>{hint}</span>}
      </div>
      <div className={styles.control}>
        {typeof children === 'function' ? children(id) : children}
      </div>
    </div>
  );
}
